import React, { useMemo, useState } from 'react';

type ChatMessage = {
  id: string;
  role: 'ai' | 'player';
  content: string;
};

type SuspiciousPoint = {
  id: string;
  title: string;
  keywords: string[];
  analysis: string;
  hint: string;
};

const FlightDelayScenario: React.FC = () => {
  const realSms = `【中国西方航空】尊敬的旅客您好，很抱歉通知您，您乘坐的9月15日 MU5888（北京首都-上海虹桥）航班因公司运力调配预计延误3.5小时。为表歉意，我们将根据《运输总条件》为您提供电子延误补偿400元。

您可通过以下任一方式领取：
① 登录【中国西方航空】官方APP或小程序，进入“航班延误”专区一键领取；
② 点击官方链接 chinawestair.com/claim 按页面提示操作。

请保留好登机牌或电子行程单。如需退改签，请联系原购票渠道或拨打客服热线 955XX。感谢您的理解，祝您旅途顺利。回T退订`;

  const scamSms = `【中国西方航空】尊敬的旅客您好，很抱歉通知您，您乘坐的MU5888航班因起落架故障已取消，现为您办理理赔，请立即点击链接 xi-fang.vip/pay 填写银行卡信息领取补偿金800元，今日截止！退订回T`;

  const messageList = [
    {
      id: 'scam',
      sender: '西部航空',
      number: '+639123456789',
      preview: '尊敬的旅客您好，您乘坐的MU5888航班已取消，请立即点击链接理赔...',
      content: scamSms
    },
    {
      id: 'fish',
      sender: '某鱼',
      number: '13340554027',
      preview: '【某鱼拍卖】“万宝尤144双色尖”正在竞拍...',
      content: '【某鱼拍卖】“万宝尤144双色尖”正在竞拍，点击查看详情。'
    },
    {
      id: 'express',
      sender: 'XX快递',
      number: '1069XXXXXXX',
      preview: '【取件通知】他人寄给您的快件“...”已到站，请及时取件。',
      content: '【取件通知】他人寄给您的快件“...”已到站，请及时取件。'
    },
    {
      id: 'antifraud',
      sender: '市反诈中心',
      number: '12381',
      preview: '提醒：近期冒充客服退款诈骗高发，请勿随意点击陌生链接。',
      content: '提醒：近期冒充客服退款诈骗高发，请勿随意点击陌生链接。'
    },
    {
      id: 'mobile',
      sender: '中国移动',
      number: '10086',
      preview: '【服务提醒】中国移动APP焕新升级，点击了解新功能。',
      content: '【服务提醒】中国移动APP焕新升级，点击了解新功能。'
    },
    {
      id: 'real',
      sender: '西部航空',
      number: '95640',
      preview: '尊敬的旅客您好，您乘坐的9月15日MU5888航班预计延误...',
      content: realSms
    }
  ];

  const suspiciousPoints: SuspiciousPoint[] = [
    {
      id: 'sender',
      title: '发件人号码异常',
      keywords: ['发件', '号码', '号', '境外', '国际', '+63', '+639', '短号', '95', '手机号'],
      analysis: '境外私人号与国内航空公司官方短信号不匹配，风险极高。',
      hint: '先关注发件号码的格式是否像航空公司常用短号。'
    },
    {
      id: 'domain',
      title: '链接域名可疑',
      keywords: ['链接', '域名', '网址', 'vip', 'xi-fang'],
      analysis: '非常规域名且直接指向支付页面，常见于钓鱼链接。',
      hint: '看看短信中的网址是否与官方航空公司域名一致。'
    },
    {
      id: 'amount',
      title: '补偿金额偏高',
      keywords: ['金额', '补偿', '赔偿', '800', '高额'],
      analysis: '金额明显偏高，利用高额诱惑降低警惕。',
      hint: '留意补偿金额是否异常偏高。'
    },
    {
      id: 'bank',
      title: '索要银行卡信息',
      keywords: ['银行卡', '卡号', '填写', '支付', '账户', '信息'],
      analysis: '正规赔付不会索要银行卡敏感信息。',
      hint: '观察是否要求填写敏感金融信息。'
    },
    {
      id: 'deadline',
      title: '紧迫话术',
      keywords: [
        '立即', '马上', '立刻', '尽快', '赶紧', '速办',
        '今日', '今天', '当日', '限时', '限期', '截止', '倒计时', '最后',
        '紧迫', '紧急', '催促', '催办', '施压', '逼迫', '压力', '焦虑', '慌张'
      ],
      analysis: '制造紧迫感是诈骗常见话术。',
      hint: '注意是否用“立即/截止”等词制造压力。'
    }
  ];

  const initialMessages: ChatMessage[] = [
    {
      id: 'intro',
      role: 'ai',
      content: '用你的火眼金睛，洞察五个可疑点吧！'
    }
  ];

  const [selectedMessageId, setSelectedMessageId] = useState<string | null>(null);
  const [foundPoints, setFoundPoints] = useState<string[]>([]);
  const [guessText, setGuessText] = useState('');
  const [linkStatus, setLinkStatus] = useState<'idle' | 'success' | 'fail'>('idle');
  const [linkMessage, setLinkMessage] = useState('');
  const [messages, setMessages] = useState<ChatMessage[]>([...initialMessages]);

  const selectedMessage = useMemo(
    () => messageList.find(item => item.id === selectedMessageId) || null,
    [messageList, selectedMessageId]
  );

  const normalize = (text: string) => text.replace(/\s+/g, '').toLowerCase();

  const handleLinkClick = (type: 'official' | 'scam') => {
    if (linkStatus !== 'idle') {
      setMessages(prev => [
        ...prev,
        { id: `ai-link-repeat-${Date.now()}`, role: 'ai', content: '链接已判定，如需重试请刷新页面。' }
      ]);
      return;
    }

    if (type === 'official') {
      setLinkStatus('success');
      setLinkMessage('你点击了官方链接，领取通道正确，判定胜利！');
      setMessages(prev => [
        ...prev,
        { id: `ai-link-success-${Date.now()}`, role: 'ai', content: '判断正确：官方链接可以安全办理。' }
      ]);
      return;
    }

    setLinkStatus('fail');
    setLinkMessage('你点击了诈骗链接，已触发风险，判定失败。');
    setMessages(prev => [
      ...prev,
      { id: `ai-link-fail-${Date.now()}`, role: 'ai', content: '你点击了诈骗链接，应该立刻停止并联系官方渠道核实。' }
    ]);
  };

  const handleRetry = () => {
    setSelectedMessageId(null);
    setFoundPoints([]);
    setGuessText('');
    setLinkStatus('idle');
    setLinkMessage('');
    setMessages([...initialMessages]);
  };

  const renderSmsContent = (content: string) => {
    const parts = content.split(/(chinawestair\.com\/claim|xi-fang\.vip\/pay)/g);
    return parts.map((part, index) => {
      if (part === 'chinawestair.com/claim') {
        return (
          <button
            key={`link-official-${index}`}
            type="button"
            onClick={() => handleLinkClick('official')}
            className="text-blue-600 underline font-medium hover:text-blue-700"
          >
            {part}
          </button>
        );
      }
      if (part === 'xi-fang.vip/pay') {
        return (
          <button
            key={`link-scam-${index}`}
            type="button"
            onClick={() => handleLinkClick('scam')}
            className="text-blue-600 underline font-medium hover:text-blue-700"
          >
            {part}
          </button>
        );
      }
      return <span key={`text-${index}`}>{part}</span>;
    });
  };

  const handleGuess = () => {
    const trimmed = guessText.trim();
    if (!trimmed) return;

    const normalized = normalize(trimmed);
    const alreadyMatched = suspiciousPoints.find(point =>
      foundPoints.includes(point.id) && point.keywords.some(keyword => normalized.includes(keyword))
    );

    setMessages(prev => [
      ...prev,
      { id: `player-${Date.now()}`, role: 'player', content: trimmed }
    ]);

    if (alreadyMatched) {
      setMessages(prev => [
        ...prev,
        { id: `ai-repeat-${Date.now()}`, role: 'ai', content: '这个可疑点已经找到了，再试试别的方向。' }
      ]);
      setGuessText('');
      return;
    }

    const remainingPoints = suspiciousPoints.filter(point => !foundPoints.includes(point.id));
    const matchedPoint = remainingPoints.find(point =>
      point.keywords.some(keyword => normalized.includes(keyword))
    );

    if (!matchedPoint) {
      setMessages(prev => [
        ...prev,
        { id: `ai-miss-${Date.now()}`, role: 'ai', content: '还没有命中可疑点，再观察一下短信内容吧。' }
      ]);
      setGuessText('');
      return;
    }

    const updatedFound = [...foundPoints, matchedPoint.id];
    setFoundPoints(updatedFound);

    setMessages(prev => [
      ...prev,
      { id: `ai-hit-${Date.now()}`, role: 'ai', content: `恭喜你找到第${updatedFound.length}个可疑点。` },
      { id: `ai-analysis-${Date.now()}`, role: 'ai', content: `解析：${matchedPoint.analysis}` }
    ]);
    setGuessText('');
  };

  const handleHint = () => {
    const remainingPoints = suspiciousPoints.filter(point => !foundPoints.includes(point.id));
    if (remainingPoints.length === 0) {
      setMessages(prev => [
        ...prev,
        { id: `ai-done-${Date.now()}`, role: 'ai', content: '你已经找齐全部可疑点啦！' }
      ]);
      return;
    }

    const hint = remainingPoints[0].hint;
    setMessages(prev => [
      ...prev,
      { id: `ai-hint-${Date.now()}`, role: 'ai', content: `提示：${hint}` }
    ]);
  };

  const allFound = foundPoints.length === suspiciousPoints.length;

  return (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-blue-50 to-sky-50 border border-blue-200 rounded-xl p-6">
        <h4 className="text-2xl font-bold text-blue-800 mb-2">航班延误短信辨伪</h4>
        <p className="text-gray-700">
          你同时收到一条真实短信和一条高度仿真的诈骗短信。请通过比对发件人号码、链接域名、赔偿金额等差异，找出可疑之处。
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white border-2 border-gray-200 rounded-xl p-5">
          <div className="flex items-center justify-between mb-3">
            <h5 className="text-lg font-semibold text-gray-800">短信列表</h5>
            <span className="text-xs text-gray-500">点击查看内容</span>
          </div>
          <div className="max-h-72 overflow-y-auto pr-2 space-y-3">
            {messageList.map(msg => {
              const isSelected = msg.id === selectedMessageId;
              return (
                <button
                  key={msg.id}
                  onClick={() => setSelectedMessageId(msg.id)}
                  className={`w-full text-left rounded-lg p-3 border transition ${
                    isSelected ? 'border-blue-300 bg-blue-50' : 'border-gray-200 bg-gray-50 hover:bg-gray-100'
                  }`}
                >
                  <div className="flex justify-between text-sm text-gray-600">
                    <span className="font-medium text-gray-800">{msg.sender}</span>
                    <span>刚刚</span>
                  </div>
                  <p className="text-sm text-gray-700 mt-1">{msg.preview}</p>
                </button>
              );
            })}
          </div>
        </div>

        <div className="bg-white border-2 border-gray-200 rounded-xl p-5">
          <h5 className="text-lg font-semibold text-gray-800 mb-3">短信内容</h5>
          {selectedMessage ? (
            <div className="space-y-3">
              <div className="text-sm text-gray-600">
                发件人：{selectedMessage.sender} · {selectedMessage.number}
              </div>
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                <div className="text-sm text-gray-700 whitespace-pre-line">
                  {renderSmsContent(selectedMessage.content)}
                </div>
              </div>
              {linkStatus !== 'idle' && (
                <div
                  className={`rounded-lg p-3 text-sm ${
                    linkStatus === 'success'
                      ? 'bg-emerald-50 border border-emerald-200 text-emerald-700'
                      : 'bg-red-50 border border-red-200 text-red-700'
                  }`}
                >
                  {linkMessage}
                </div>
              )}
              {linkStatus === 'fail' && (
                <button
                  type="button"
                  onClick={handleRetry}
                  className="mt-3 w-full px-4 py-2 bg-gray-900 text-white rounded-lg font-medium hover:bg-gray-800 transition"
                >
                  回到最初的起点。。。
                </button>
              )}
            </div>
          ) : (
            <div className="bg-gray-50 border border-dashed border-gray-300 rounded-lg p-6 text-sm text-gray-500">
              请在左侧列表点击短信查看内容。
            </div>
          )}
        </div>
      </div>

      <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
        <div className="flex items-center justify-between mb-4">
          <h5 className="text-lg font-semibold text-gray-800">AI主持人</h5>
          <span className="text-sm text-gray-500">已找到 {foundPoints.length} / {suspiciousPoints.length}</span>
        </div>

        <div className="h-64 overflow-y-auto border border-gray-200 rounded-lg p-4 bg-gray-50 space-y-3">
          {messages.map(message => (
            <div key={message.id} className={message.role === 'player' ? 'text-right' : 'text-left'}>
              <span
                className={`inline-block px-4 py-2 rounded-lg text-sm ${
                  message.role === 'player'
                    ? 'bg-blue-500 text-white'
                    : 'bg-white text-gray-700 border border-gray-200'
                }`}
              >
                {message.content}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-4 flex flex-wrap gap-3">
          <input
            value={guessText}
            onChange={(event) => setGuessText(event.target.value)}
            placeholder="请输入你发现的可疑点描述"
            className="flex-1 min-w-[220px] px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200"
          />
          <button
            onClick={handleGuess}
            className="px-5 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition"
          >
            猜答案
          </button>
          <button
            onClick={handleHint}
            className="px-5 py-2 bg-amber-500 text-white rounded-lg font-medium hover:bg-amber-600 transition"
          >
            提示
          </button>
        </div>
      </div>

      {allFound && (
        <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-6">
          <h5 className="text-lg font-semibold text-yellow-800 mb-2">识别要点总结</h5>
          <ul className="text-sm text-gray-700 space-y-1">
            <li>核验发件人：航空公司通常使用95开头短号或官方客服号。</li>
            <li>核验域名：官方域名与企业名称一致，避免点击陌生后缀链接。</li>
            <li>警惕高额赔付与紧迫话术：越着急越要冷静核实。</li>
            <li>正规赔付不会索取银行卡敏感信息。</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default FlightDelayScenario;
